import React from 'react'
import 'photoswipe/dist/photoswipe.css'
import { Gallery, Item } from 'react-photoswipe-gallery'
import CustomImage from '../../uielements/Image'
import { Box, SimpleGrid } from '@chakra-ui/react'

const PhotoSwipeGallery = ({ images }) => {

    const options = {
        arrowPrev: true,
        arrowNext: true,
        zoom: false,
        close: true,
        counter: true,
        bgOpacity: 0.7,
        // padding: { top: 20, bottom: 40, left: 100, right: 100 },
    }

    return (
        images && (
            <div>
                <SimpleGrid columns={[2, 3, 4, 5]} spacing={[2, 3, 6]} mt={8}>
                    <Gallery options={options}>
                        {images?.map((image) => (
                            <Item
                                key={image.title}
                                original={image.url}
                                thumbnail={image.url}
                                caption={image.title}
                                width={image.width}
                                height={image.height}
                            >
                                {/*{({ ref, open }) => <img ref={ref} onClick={open} src={image.url} width={200} />}*/}
                                {({ ref, open }) => (
                                    <Box
                                        ref={ref}
                                        onClick={open}
                                        height={['160', '200px']}
                                        overflow={'hidden'}
                                        p={2}
                                        borderColor={'brand.blue'}
                                        borderRadius={8}
                                        borderWidth={'2px'}
                                        _hover={{
                                            bgColor: 'brand.blue',
                                            cursor: 'pointer',
                                        }}
                                    >
                                        <CustomImage obj={image} fit={'cover'} />
                                    </Box>
                                )}
                            </Item>
                        ))}
                    </Gallery>
                </SimpleGrid>
            </div>
        )
    )
}

export default PhotoSwipeGallery
